module.exports = __webpack_public_path__ + "static/media/ribbetjes.433ad31f.jpg";